export default __webpack_public_path__ + "static/media/postnl-logo.644b6896.jpg";